// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInExistingAccountStyles } from "@synd/Overrides/Widgets/SignIn/SignInExistingAccount";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { css } from "styled-components";

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h3",
    color: "common.ui7",
};

signInExistingAccountStyles.signInGridContainer = {
    gap: 12,
};
signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: fontConfig.xSmall.size,
    },
};

signInExistingAccountStyles.signInButton = {
    variant: "primary",
    css: css`
        margin-top: 4px;
    `,
};
signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
    `,
};
signInExistingAccountStyles.resetPasswordModal = {
    sizeVariant: "small",
    cssOverrides: {
        modalContent: css`
            font-size: ${fontConfig.small.size}px;
        `,
    },
};
